<template>
    <div>
    <div v-if="loading">
        <Loading/>
    </div>
    <v-container fluid v-if="isAdmin && !loading">
    <v-btn class="primary" @click="ExportExcel()">Download to excel</v-btn>
    <v-card-title>
         <h2 class="primary--text"> Deleted bookings </h2>
          <v-spacer> </v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search ..."
            single-line
            hide-details
          >
          </v-text-field> 
    </v-card-title>
        <v-data-table
          id="table"
          dense
          :headers="headers"
          :items="deletedBookings"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100, -1]
          }"
          :search="search"
          class="elevation-1"
        >
        </v-data-table>
    </v-container>
      </div>
    </template>
    <script>
    import 'table2excel';
    import Loading from '@/components/Loading.vue';
    export default {
      name: 'deletedBookings',
      props: {
        bookings: Array
      },
      components: {
        Loading
      },
      data() {
        return {
          headers: [
            {
              text: 'Id',
              align: 'start',
              sortable: true,
              value: 'id',
            },
            { text: 'Order Number', value: 'orderNumber' },
            { text: 'Customer', value: 'customer' },
            { text: 'Company', value: 'company' },
            { text: 'Date', value: 'date' },
            { text: 'Address', sortable: false, value: 'address' },
            { text: 'Waste', sortable: false, value: 'wasteName' },
            { text: 'Vehicle', sortable: false, value: 'vehicleName' },
            { text: 'Type', sortable: false, value: 'type' }
          ],
          bookingData: [],
          search: '',
        }
      },
    
      computed: {
        isAdmin() {
          return this.$store.getters['auth/isAdmin'];
        },
        deletedBookings(){
          return this.$store.getters['admin/getDeletedBookings'];
        },
        loading(){
          return this.$store.getters['admin/getLoading'];
        }
      },
      methods:{
        ExportExcel() {
          const Table2Excel = window.Table2Excel;
          const table2excel = new Table2Excel();
          table2excel.export(document.querySelectorAll("table"));
        }
      },
      mounted() {
        this.$store.dispatch('admin/fetchDeletedBookings');
      }
    }
    </script>
    
    <style scoped>
    
    </style>
    